import $ from "jquery";

import Menu from './modules/menu';
import Carousel from './modules/carousel';
import Form from './modules/form';
import Modal from './modules/modal';
import Pagination from './modules/pagination';
import SmoothScroll from './modules/smoothscroll';

window.addEventListener('DOMContentLoaded', function () {

    $("#preload").fadeOut(300);

    var lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy"
    });

    Menu.run();
    Carousel.run();
    Form.run();
    Modal.run();
    Pagination.run();
    SmoothScroll.run();

    // Add #TabId on URL of Homepage Resolve
    let url = location.href.replace(/\/$/, "");

    $('.serviceTabResolve').on("click", function () {
        let newUrl;
        
        var enteredUrl = "#" + url.split("#")[1];

        const hash = $(this).attr("href");

        if (enteredUrl == "#undefined") {
            newUrl = url.split("/\\/#")[0] + "/" + hash;
        } else if (enteredUrl != hash || enteredUrl == hash) {
            newUrl = url.split("#")[0] + hash;
        }
        history.replaceState(null, null, newUrl);
    });
    // End of Add #TabId on URL of Homepage Resolve
});


$('document').ready(() => {
    // Add #TabId on URL of Homepage Resolve
    let url = location.href.replace(/\/$/, "");
    if (location.hash && url.split("/")[3] == "corsi") {
        setTimeout(function () {
           
            const cat = url.split("/")[4].split('#')[1];
            console.log(cat);
            $('[data-category]').parent().hide();

            let posts = $('[data-category-slug="' + cat + '"]');
            posts.addClass('active');
            posts.parent().show();

            $(".btn-load-more").fadeOut('slow');
            $('.category[data-slug="'+ cat +'"]').addClass('active');
        });
    } else if (location.hash && $('.serviceTabResolve').length) {
        const hash = url.split("/");
        console.log('url IF location hash', hash[4]);

        $(hash[4]).addClass("show");
        $(hash[4]).addClass("active");

        history.replaceState(null, null, url);

        $(".btn-load-more").fadeIn('slow');

        var activeHrefValue = $('a[href="' + hash[4] + '"]');
        $('.serviceTabResolve').removeClass('active');
        setTimeout(() => $(hash[4] + '_').addClass("active"), 100);

        activeHrefValue.addClass("active");

        // setTimeout(() => {
        //     $('html, body').animate({
        //         scrollTop: $('.s-our-services').offset().top
        //     }, 500);
        // }, 1400);
    } else {
        $('.serviceTabResolve').removeClass('active');
    }

    /****** Elements event handling*****/
    $('.category').on('click', function () {
        if (window.location.href.indexOf("corsi") > -1) {
            $('.category').removeClass('active');
            $(this).toggleClass('active');

            let url = location.href.replace(/\/$/, "");

            let newUrl;

            var enteredUrl = "/" + url.split("/")[3];

            var defurl = 'https://www.ergongroup.it/corsi/';

            const hash = $(this).attr('data-slug');
            console.log('Hash  -->', hash);
            if (enteredUrl == "/corsi") {
                newUrl = defurl + '#' + hash;
            } else if (enteredUrl != hash || enteredUrl == hash) {

                newUrl = url.split("/")[3] + "/" + hash;
            }

            history.replaceState(null, null, newUrl);

            var cat = '';
            if ($(this).text().indexOf('#') === -1) {
                cat = $(this).text();
            } else {
                cat = $(this).text().substr($(this).text().indexOf('#') + 1, $(this).text().length);
            }

            if (cat !== 'Tutto') {
                $('[data-category]').parent().hide();
                const tease = $('[data-category="' + cat + '"]');
                tease.parent().slice(0, 9).fadeIn(200);
                if ($('[data-category="' + cat + '"]:hidden').length == 0) {
                    $(".btn-load-more").fadeOut('slow');
                } else {
                    $(".btn-load-more:hidden").fadeIn('slow');
                }
            } else {
                $('[data-category]').parent().fadeOut(200);
                $(".tease-wrapper").slice(0, 9).fadeIn(200);
                if ($('[data-category]:hidden').length == 0) {
                    $(".btn-load-more").fadeOut('slow');
                } else {
                    $(".btn-load-more:hidden").fadeIn('slow');
                }
            }
        } else if (window.location.href.indexOf("/blog") > -1) {

            $('.category').removeClass('active');
            $(this).toggleClass('active');

            let url = location.href.replace(/\/$/, "");

            let newUrl;

            var enteredUrl = "/" + url.split("/")[3];

            var defurl = 'https://www.ergongroup.it/blog/';

            const hash = $(this).attr('data-category');

            if (enteredUrl == "/corsi") {
                newUrl = defurl + '#' + hash;
            } else if (enteredUrl != hash || enteredUrl == hash) {
                newUrl = url.split("/")[3] + "/" + hash;
            }


            var cat = '';
            if ($(this).text().indexOf('#') === -1) {
                cat = $(this).text();
            } else {
                cat = $(this).text().substr($(this).text().indexOf('#') + 1, $(this).text().length);
            }

            if (cat !== 'Tutto') {
                $('[data-category]').parent().hide();
                const tease = $('[data-category="' + cat + '"]');
                tease.parent().slice(0, 9).fadeIn(200);
                if ($('[data-category="' + cat + '"]:hidden').length == 0) {
                    $(".btn-load-more").fadeOut('slow');
                } else {
                    $(".btn-load-more:hidden").fadeIn('slow');
                }
            } else {
                $('[data-category]').parent().fadeOut(200);
                $(".tease-wrapper").slice(0, 9).fadeIn(200);
                if ($('[data-category]:hidden').length == 0) {
                    $(".btn-load-more").fadeOut('slow');
                } else {
                    $(".btn-load-more:hidden").fadeIn('slow');
                }
            }
        }
    });

    $('.tag').on('click', function () {
        $('.tag').removeClass('active');
        $(this).toggleClass('active');
        var tag = '';
        if ($(this).text().indexOf('#') === -1) {
            tag = $(this).text();
        } else {
            tag = $(this).text().substr($(this).text().indexOf('#') + 1, $(this).text().length)
        }

        $('[data-tags]:not([data-tags*=' + tag + ']').parent().hide();
        $('[data-tags*=' + tag + ']').parent().fadeIn(200);

    });
    /****** End elements event handling*****/
});
